<div class="flex flex-row space-x-3 items-start">
  <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }" class="basis-4/6">
    <mat-label i18n>Длина</mat-label>
    <input
      data-testId="lengthInput"
      type="number"
      [ngModel]="_value"
      #V="ngModel"
      (ngModelChange)="V.invalid ? null : valueChange.emit($event)"
      matInput
      required
      [range]="[min, max]"
      number
      (click)="$any($event.target).select()"
      [disabled]="!editable" />
    <div i18n matSuffix>мм</div>
    <mat-error *ngIf="V.invalid"> ≥{{ min }}, ≤{{ max }} </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }" class="basis-2/6">
    <mat-label i18n>Расположение</mat-label>
    <mat-select [ngModel]="_orientation" (ngModelChange)="orientationChange.emit($event)" [disabled]="!editable">
      <mat-option [value]="thisMasonsMitreOrientationEnum.AlongHeight"> По длине </mat-option>

      <mat-option [value]="thisMasonsMitreOrientationEnum.AlongWidth"> По ширине </mat-option>
    </mat-select>
  </mat-form-field>
</div>
